import { render, staticRenderFns } from "./MarkClassificationAsDone.vue?vue&type=template&id=a62392c4&scoped=true"
import script from "./MarkClassificationAsDone.vue?vue&type=script&lang=js"
export * from "./MarkClassificationAsDone.vue?vue&type=script&lang=js"
import style0 from "./MarkClassificationAsDone.vue?vue&type=style&index=0&id=a62392c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62392c4",
  null
  
)

export default component.exports